export const FileOrigin = {
	CLIENT: 'client',
	SERVER: 'server',
};